import { Box } from "@mui/material";
import { CsDashboardLayout, CsDrawer, CsFooter } from "@com.ctu.iotlab/ui-library";
import { getDashboardAdmin } from "src/constant/role";
import { getRoleKeyCloak } from "src/utils/getRoleKeycloak";
import { useKeycloak } from "src/contexts/KeycloakContext";
import config from "src/config";
import HeaderObs from "src/components/Header";
import Logo from "./Logo";

export const DashboardLayoutObs = () => {
  const { token } = useKeycloak();

  const arrRole = token ? getRoleKeyCloak(token) : [];
  const dashboardMenu = getDashboardAdmin(arrRole);

  return (
    <CsDashboardLayout
      drawer={
        <Box >
          <CsDrawer
            logo={<Logo />}
            dashboardMenu={dashboardMenu}
            version="v2.0.0"
            onLogoClick={() => window.location.href = `${config.PUBLIC_URL_BACK}/dashboard`}
          />
        </Box>
      }
      header={<Box sx={{ borderBottom: "1px solid #dbdfe6" }}><HeaderObs /></Box>}
      footer={<CsFooter />}
    />

  );
};
